// extracted by mini-css-extract-plugin
export var radioInputRow = "B_vK";
export var radioInputColumn = "B_vL";
export var inputOptionRow = "B_sy";
export var inputOptionColumn = "B_sz";